<div *ngIf="!checklistItemList || (checklistItemList && checklistItemList.length === 0)" class="empty-checklist">
  <p>Die Checkliste ist leer.</p>
</div>
<div *ngIf="checklistItemList && checklistItemList.length > 0"
     class="mat-expansion-panel-content checklist-table-container">
  <table mat-table [dataSource]="checklistItemList" class="mat-elevation">
    <!--ChecklistItem Column-->
    <ng-container matColumnDef="checklistItem">
      <th class="checklist-table-head" mat-header-cell *matHeaderCellDef>Eintrag</th>
      <td mat-cell
          *matCellDef="let element">{{ element.def && element.def.label ? element.def.label : 'Checklistitem' }}
      </td>
    </ng-container>
    <!--Status Column-->
    <ng-container matColumnDef="checklistStatus">
      <th class="checklist-table-head" mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">{{ getChecklistStatusLabel(element.status) }}</td>
    </ng-container>
    <!--CheckIcon Column-->
    <ng-container matColumnDef="checklistCheck">
      <th class="checklist-table-head" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon>
          {{ getChecklistCheckIcon(element.status) }}
        </mat-icon>
      </td>
    </ng-container>
    <!--Edit Column-->
    <ng-container matColumnDef="checklistEdit">
      <th class="checklist-table-head" mat-header-cell *matHeaderCellDef>Bearbeiten</th>
      <td mat-cell *matCellDef="let element">
        <div (click)="selectItem(element)">
          <button mat-icon-button [disabled]="editDisabled">
            <mat-icon>create</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
